export const API_PATH_ApiTrafficStudyPut = '/services/traffic-studies/apiTrafficStudyPut';
